var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"py-10 bg-cover",style:({
            backgroundImage: ("url(" + _vm.backgroundImage + ")"),
            backgroundColor: _vm.backgroundColor
        })},[_c('h2',{staticClass:"font-primary text-4xl text-white text-center text-white"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"w-full"},[_c('slider',{attrs:{"items":_vm.series,"options":_vm.sliderOptions},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var serie = ref.item;
return [_c('serie',{attrs:{"serie":serie}})]}}])})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }